/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Gratitude_TitleInputs */

const en_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To you, who grew with us.`)
};

const ar_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إليكم، يا من كبرتم معنا.`)
};

const de_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf dich, der du mit uns gewachsen bist.`)
};

const es_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para ti, que has crecido con nosotros.`)
};

const fr_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À vous, qui avez grandi avec nous.`)
};

const it_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A te, che sei cresciuto con noi.`)
};

const ja_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ともに成長してきたあなたへ`)
};

const ko_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forest와 함께 성장한 사용자님께,`)
};

const pt_br_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A você, que cresceu conosco.`)
};

const ru_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для вас — того, кто рос вместе с нами.`)
};

const th_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แด่คุณ ผู้ที่เติบโตไปพร้อมกับเรา`)
};

const tr_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bizimle birlikte büyüyen sizlere.`)
};

const zh_cn_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给一路陪着 Forest 的你`)
};

const zh_tw_pro_user_appreciation_letter_gratitude_title = /** @type {(inputs: Pro_User_Appreciation_Letter_Gratitude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`給一路陪著 Forest 的你`)
};

/**
* | output |
* | --- |
* | "To you, who grew with us." |
*
* @param {Pro_User_Appreciation_Letter_Gratitude_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_gratitude_title = /** @type {((inputs?: Pro_User_Appreciation_Letter_Gratitude_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Gratitude_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_gratitude_title(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_gratitude_title(inputs)
	return zh_tw_pro_user_appreciation_letter_gratitude_title(inputs)
});